import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';
import PageLoading from '@/account/pages/PageLoading';
import i18n from '@/i18n';
import { I18nextProvider } from 'react-i18next';

class AddAccessoriesPopUpLoader {
  static load({ entry }) {
    const AddAccessoriesLazy = Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "popup-add-accessories" */ '@/components/popup/AddAccessories'
        ),
      loading: PageLoading,
    });
    ReactDOM.render(
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<div />}>
          <AddAccessoriesLazy item={entry} />
        </Suspense>
      </I18nextProvider>,
      document.getElementById('js-dln-popup__wrapper'),
    );
  }
}

export default AddAccessoriesPopUpLoader;
